export default __webpack_public_path__ + "static/Aditya Fendy Heryanto-e16784d112deb31631a3344f16f8a208.webp";